import { TypePolicies, TypePolicy } from '@apollo/client/core';

export default {
} satisfies TypePolicies;
